// extracted by mini-css-extract-plugin
export default {"Input":"Input_Input__DK2v6","Label":"Input_Label__yHWMN","InputElement":"Input_InputElement__6cLNM","Invalid":"Input_Invalid__+knfm"};